import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/site";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto"
      className="relative overflow-hidden border-t border-white/10 bg-[#080808] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-16 grid gap-8 md:grid-cols-2 md:items-end">
          <h2 className="font-display text-4xl md:text-6xl font-medium tracking-tight">
            Why property owners
            <br />
            choose <span className="text-cyanbrand">SC Security.</span>
          </h2>
          <div className="relative h-52 overflow-hidden border border-white/10">
            <img
              src="https://images.pexels.com/photos/11651938/pexels-photo-11651938.jpeg"
              alt="Commercial surveillance camera"
              className="h-full w-full object-cover grayscale contrast-125"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#080808]/60 to-transparent" />
            <span className="absolute bottom-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] text-white/60">
              Commercial estate · London
            </span>
          </div>
        </div>

        <div className="divide-y divide-white/10 border-y border-white/10">
          {MANIFESTO.map((m) => (
            <motion.div
              key={m.no}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              data-testid={`manifesto-${m.no}`}
              className="group grid grid-cols-1 gap-4 py-8 md:grid-cols-[120px_1fr_1.4fr] md:items-center md:gap-10"
            >
              <span className="font-display text-5xl md:text-7xl font-semibold text-white/10 transition-colors duration-300 group-hover:text-cyanbrand/30">
                {m.no}
              </span>
              <h3 className="font-display text-xl md:text-2xl font-medium tracking-tight">
                {m.title}
              </h3>
              <p className="font-body text-sm md:text-base text-white/55 leading-relaxed">
                {m.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
